var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"BrandSwitching"}},[_c('keep-alive',{attrs:{"include":"centre"}},[_c('company-switch',{attrs:{"dataList":_vm.dataList},on:{"companySwitching":_vm.switchingChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }